/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * @example
 *     {}
 */
export interface SchemaLatestRequest {
    /** The ETag of the latest version of the resource. */
    ifNoneMatch?: string;
}
